import React, { Fragment } from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import _12x101 from "./12x101.png";
import _12x102 from "./12x102.png";
import _12x103 from "./12x103.png";

const width = "70%";
const height = "auto";
const viewBox = "0 0 343 193";

const getDimensions = (size, sizes) => {
  if (
    size &&
    typeof size.width === "number" &&
    typeof size.height === "number"
  ) {
    return size;
  }
  return size && sizes[size] ? sizes[size] : { width, height };
};

const getCss = (size, sizes, fillColor, fillColorRule, noStyles) => {
  if (noStyles) {
    return "";
  }
  const dimensions = getDimensions(size, sizes);
  const fillRule =
    fillColor && fillColorRule ? `${fillColorRule}{ fill: ${fillColor}; }` : "";
  return css`
    width: ${dimensions.width};
    height: ${dimensions.height};
    ${fillRule};
  `;
};

const propsToCss = ({ size, sizes, fillColor, fillColorRule, noStyles }) =>
  getCss(size, sizes, fillColor, fillColorRule, noStyles);

const Image = styled.svg`
  ${propsToCss};
`;

const children = (
  <Fragment>
    <defs key="key-0">
      <linearGradient
        id="s-5a64174af5-a"
        x1="-2628.78"
        x2="-2628.53"
        y1="344.77"
        y2="344.77"
        gradientTransform="matrix(-1 0 0 1 -2461.61 -272.88)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#595959" />
        <stop offset=".5" stopColor="#949494" />
        <stop offset="1" stopColor="#5c5c5c" />
      </linearGradient>
      <linearGradient
        id="s-5a64174af5-d"
        x1="-2627.6"
        x2="-2627.35"
        y1="344.71"
        y2="344.71"
        xlinkHref="#s-5a64174af5-a"
      />
      <linearGradient
        id="s-5a64174af5-e"
        x1="-2626.48"
        x2="-2626.23"
        y1="344.65"
        y2="344.65"
        xlinkHref="#s-5a64174af5-a"
      />
      <linearGradient
        id="s-5a64174af5-f"
        x1="-2625.37"
        x2="-2625.12"
        y1="344.57"
        y2="344.57"
        xlinkHref="#s-5a64174af5-a"
      />
      <linearGradient
        id="s-5a64174af5-g"
        x1="-2624.19"
        x2="-2623.94"
        y1="344.5"
        y2="344.5"
        xlinkHref="#s-5a64174af5-a"
      />
      <linearGradient
        id="s-5a64174af5-h"
        x1="-2623.07"
        x2="-2622.82"
        y1="344.44"
        y2="344.44"
        xlinkHref="#s-5a64174af5-a"
      />
      <linearGradient
        id="s-5a64174af5-i"
        x1="-2621.95"
        x2="-2621.7"
        y1="344.37"
        y2="344.37"
        xlinkHref="#s-5a64174af5-a"
      />
      <linearGradient
        id="s-5a64174af5-j"
        x1="-2620.76"
        x2="-2620.51"
        y1="344.3"
        y2="344.3"
        xlinkHref="#s-5a64174af5-a"
      />
      <linearGradient
        id="s-5a64174af5-k"
        x1="-2619.65"
        x2="-2619.4"
        y1="344.23"
        y2="344.23"
        xlinkHref="#s-5a64174af5-a"
      />
      <linearGradient
        id="s-5a64174af5-l"
        x1="-2618.54"
        x2="-2618.29"
        y1="344.17"
        y2="344.17"
        xlinkHref="#s-5a64174af5-a"
      />
      <linearGradient
        id="s-5a64174af5-m"
        x1="-2617.35"
        x2="-2617.1"
        y1="344.13"
        y2="344.13"
        xlinkHref="#s-5a64174af5-a"
      />
      <linearGradient
        id="s-5a64174af5-n"
        x1="-2616.24"
        x2="-2615.99"
        y1="344.01"
        y2="344.01"
        xlinkHref="#s-5a64174af5-a"
      />
      <linearGradient
        id="s-5a64174af5-o"
        x1="-2615.16"
        x2="-2614.91"
        y1="343.94"
        y2="343.94"
        xlinkHref="#s-5a64174af5-a"
      />
      <linearGradient
        id="s-5a64174af5-p"
        x1="-2613.98"
        x2="-2613.73"
        y1="343.91"
        y2="343.91"
        xlinkHref="#s-5a64174af5-a"
      />
      <linearGradient
        id="s-5a64174af5-q"
        x1="-2612.86"
        x2="-2612.61"
        y1="343.85"
        y2="343.85"
        xlinkHref="#s-5a64174af5-a"
      />
      <linearGradient
        id="s-5a64174af5-r"
        x1="-2633.84"
        x2="-2617.56"
        y1="334.62"
        y2="334.62"
        gradientTransform="matrix(-.99 0 0 1 -2448.6 -265.36)"
        xlinkHref="#s-5a64174af5-a"
      />
      <linearGradient
        id="s-5a64174af5-s"
        x1="-2633.83"
        x2="-2617.55"
        y1="333.17"
        y2="333.17"
        gradientTransform="matrix(-.99 0 0 1 -2448.6 -265.36)"
        xlinkHref="#s-5a64174af5-a"
      />
      <linearGradient
        id="s-5a64174af5-t"
        x1="-2633.83"
        x2="-2617.55"
        y1="331.79"
        y2="331.79"
        gradientTransform="matrix(-.99 0 0 1 -2448.6 -265.36)"
        xlinkHref="#s-5a64174af5-a"
      />
      <linearGradient
        id="s-5a64174af5-u"
        x1="-2633.82"
        x2="-2617.54"
        y1="330.33"
        y2="330.33"
        gradientTransform="matrix(-.99 0 0 1 -2448.6 -265.36)"
        xlinkHref="#s-5a64174af5-a"
      />
      <linearGradient
        id="s-5a64174af5-v"
        x1="-2633.82"
        x2="-2617.54"
        y1="328.95"
        y2="328.95"
        gradientTransform="matrix(-.99 0 0 1 -2448.6 -265.36)"
        xlinkHref="#s-5a64174af5-a"
      />
      <linearGradient
        id="s-5a64174af5-w"
        x1="-2633.95"
        x2="-2617.67"
        y1="364.31"
        y2="364.31"
        gradientTransform="matrix(-.99 0 0 1 -2448.6 -265.36)"
        xlinkHref="#s-5a64174af5-a"
      />
      <linearGradient
        id="s-5a64174af5-x"
        x1="-2633.95"
        x2="-2617.67"
        y1="365.52"
        y2="365.52"
        gradientTransform="matrix(-.99 0 0 1 -2448.6 -265.36)"
        xlinkHref="#s-5a64174af5-a"
      />
      <linearGradient
        id="s-5a64174af5-y"
        x1="-2633.94"
        x2="-2617.66"
        y1="362.93"
        y2="362.93"
        gradientTransform="matrix(-.99 0 0 1 -2448.6 -265.36)"
        xlinkHref="#s-5a64174af5-a"
      />
      <linearGradient
        id="s-5a64174af5-z"
        x1="-2633.94"
        x2="-2617.66"
        y1="361.48"
        y2="361.48"
        gradientTransform="matrix(-.99 0 0 1 -2448.6 -265.36)"
        xlinkHref="#s-5a64174af5-a"
      />
      <linearGradient
        id="s-5a64174af5-A"
        x1="-2633.93"
        x2="-2617.65"
        y1="360.1"
        y2="360.1"
        gradientTransform="matrix(-.99 0 0 1 -2448.6 -265.36)"
        xlinkHref="#s-5a64174af5-a"
      />
      <linearGradient
        id="s-5a64174af5-B"
        x1="-2633.93"
        x2="-2617.65"
        y1="358.64"
        y2="358.64"
        gradientTransform="matrix(-.99 0 0 1 -2448.6 -265.36)"
        xlinkHref="#s-5a64174af5-a"
      />
      <linearGradient
        id="s-5a64174af5-C"
        x1="-2633.92"
        x2="-2617.64"
        y1="357.26"
        y2="357.26"
        gradientTransform="matrix(-.99 0 0 1 -2448.6 -265.36)"
        xlinkHref="#s-5a64174af5-a"
      />
      <linearGradient
        id="s-5a64174af5-D"
        x1="-2633.92"
        x2="-2617.64"
        y1="355.81"
        y2="355.81"
        gradientTransform="matrix(-.99 0 0 1 -2448.6 -265.36)"
        xlinkHref="#s-5a64174af5-a"
      />
      <linearGradient
        id="s-5a64174af5-E"
        x1="-2633.91"
        x2="-2617.63"
        y1="354.42"
        y2="354.42"
        gradientTransform="matrix(-.99 0 0 1 -2448.6 -265.36)"
        xlinkHref="#s-5a64174af5-a"
      />
      <linearGradient
        id="s-5a64174af5-F"
        x1="-2633.9"
        x2="-2617.63"
        y1="352.97"
        y2="352.97"
        gradientTransform="matrix(-.99 0 0 1 -2448.6 -265.36)"
        xlinkHref="#s-5a64174af5-a"
      />
      <linearGradient
        id="s-5a64174af5-G"
        x1="-2633.9"
        x2="-2617.62"
        y1="351.55"
        y2="351.55"
        gradientTransform="matrix(-.99 0 0 1 -2448.6 -265.36)"
        xlinkHref="#s-5a64174af5-a"
      />
      <linearGradient
        id="s-5a64174af5-H"
        x1="-2633.89"
        x2="-2617.62"
        y1="350.1"
        y2="350.1"
        gradientTransform="matrix(-.99 0 0 1 -2448.6 -265.36)"
        xlinkHref="#s-5a64174af5-a"
      />
      <linearGradient
        id="s-5a64174af5-I"
        x1="-2633.89"
        x2="-2617.61"
        y1="348.72"
        y2="348.72"
        gradientTransform="matrix(-.99 0 0 1 -2448.6 -265.36)"
        xlinkHref="#s-5a64174af5-a"
      />
      <linearGradient
        id="s-5a64174af5-J"
        x1="-2633.88"
        x2="-2617.61"
        y1="347.26"
        y2="347.26"
        gradientTransform="matrix(-.99 0 0 1 -2448.6 -265.36)"
        xlinkHref="#s-5a64174af5-a"
      />
      <linearGradient
        id="s-5a64174af5-K"
        x1="-2633.88"
        x2="-2617.6"
        y1="345.88"
        y2="345.88"
        gradientTransform="matrix(-.99 0 0 1 -2448.6 -265.36)"
        xlinkHref="#s-5a64174af5-a"
      />
      <linearGradient
        id="s-5a64174af5-L"
        x1="-2633.87"
        x2="-2617.6"
        y1="344.43"
        y2="344.43"
        gradientTransform="matrix(-.99 0 0 1 -2448.6 -265.36)"
        xlinkHref="#s-5a64174af5-a"
      />
      <linearGradient
        id="s-5a64174af5-M"
        x1="-2633.87"
        x2="-2617.59"
        y1="343.05"
        y2="343.05"
        gradientTransform="matrix(-.99 0 0 1 -2448.6 -265.36)"
        xlinkHref="#s-5a64174af5-a"
      />
      <linearGradient
        id="s-5a64174af5-N"
        x1="-2633.86"
        x2="-2617.59"
        y1="341.59"
        y2="341.59"
        gradientTransform="matrix(-.99 0 0 1 -2448.6 -265.36)"
        xlinkHref="#s-5a64174af5-a"
      />
      <linearGradient
        id="s-5a64174af5-O"
        x1="-2633.86"
        x2="-2617.58"
        y1="340.21"
        y2="340.21"
        gradientTransform="matrix(-.99 0 0 1 -2448.6 -265.36)"
        xlinkHref="#s-5a64174af5-a"
      />
      <linearGradient
        id="s-5a64174af5-P"
        x1="-2633.85"
        x2="-2617.57"
        y1="338.76"
        y2="338.76"
        gradientTransform="matrix(-.99 0 0 1 -2448.6 -265.36)"
        xlinkHref="#s-5a64174af5-a"
      />
      <linearGradient
        id="s-5a64174af5-Q"
        x1="-2633.85"
        x2="-2617.57"
        y1="337.37"
        y2="337.37"
        gradientTransform="matrix(-.99 0 0 1 -2448.6 -265.36)"
        xlinkHref="#s-5a64174af5-a"
      />
      <linearGradient
        id="s-5a64174af5-R"
        x1="-2633.84"
        x2="-2617.56"
        y1="335.92"
        y2="335.92"
        gradientTransform="matrix(-.99 0 0 1 -2448.6 -265.36)"
        xlinkHref="#s-5a64174af5-a"
      />
      <linearGradient
        id="s-5a64174af5-S"
        x1="149.52"
        x2="168.62"
        y1="70.86"
        y2="70.86"
        xlinkHref="#s-5a64174af5-a"
      />
      <radialGradient
        id="s-5a64174af5-T"
        cx="152.93"
        cy="67.61"
        r="1.36"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#999" />
        <stop offset="1" stopColor="#4d4d4d" />
      </radialGradient>
      <linearGradient
        id="s-5a64174af5-U"
        x1="470.98"
        x2="471.01"
        y1="339.84"
        y2="339.33"
        gradientTransform="matrix(1.11 .01 .01 1 -369.94 -274.4)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#4d4d4d" />
        <stop offset=".5" stopColor="#949494" />
        <stop offset="1" stopColor="#4d4d4d" />
      </linearGradient>
      <linearGradient
        id="s-5a64174af5-V"
        x1="1967.95"
        x2="1968.18"
        y1="753.86"
        y2="753.43"
        gradientTransform="rotate(-27.38 391.605 3461.088)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#d45a24" />
        <stop offset=".84" stopColor="#a2272d" />
      </linearGradient>
      <linearGradient
        id="s-5a64174af5-W"
        x1="722.74"
        x2="723.14"
        y1="1005.97"
        y2="1006.1"
        gradientTransform="matrix(-.28 -1.17 .81 -.19 -66.1 1371.56)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#f15a24" />
        <stop offset=".83" stopColor="#a6272d" />
      </linearGradient>
      <linearGradient
        id="s-5a64174af5-b"
        x1="544.56"
        x2="544.72"
        y1="331.24"
        y2="331.24"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#be1e2d" />
        <stop offset="1" stopColor="#ee4036" />
      </linearGradient>
      <linearGradient
        id="s-5a64174af5-X"
        x1="543"
        x2="552.06"
        y1="332.32"
        y2="332.32"
        xlinkHref="#s-5a64174af5-b"
      />
      <linearGradient
        id="s-5a64174af5-c"
        x1="438.68"
        x2="438.68"
        y1="386.23"
        y2="400.95"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#c1272d" />
        <stop offset=".53" stopColor="#c6594b" />
        <stop offset="1" stopColor="#c1272d" />
      </linearGradient>
      <linearGradient
        id="s-5a64174af5-Y"
        x1="422.5"
        x2="455.36"
        y1="393.01"
        y2="393.01"
        xlinkHref="#s-5a64174af5-c"
      />
      <linearGradient
        id="s-5a64174af5-Z"
        x1="444.22"
        x2="455.19"
        y1="376.01"
        y2="376.01"
        xlinkHref="#s-5a64174af5-c"
      />
      <linearGradient
        id="s-5a64174af5-aa"
        x1="423.38"
        x2="434.34"
        y1="388.34"
        y2="388.34"
        xlinkHref="#s-5a64174af5-c"
      />
      <linearGradient
        id="s-5a64174af5-ab"
        x1="433.48"
        x2="455.79"
        y1="382.79"
        y2="382.79"
        xlinkHref="#s-5a64174af5-c"
      />
      <linearGradient
        id="s-5a64174af5-ac"
        x1="434.41"
        x2="455.81"
        y1="383.18"
        y2="383.18"
        xlinkHref="#s-5a64174af5-c"
      />
      <linearGradient
        id="s-5a64174af5-ad"
        x1="-1064.42"
        x2="-1064.42"
        y1="398.27"
        y2="418.73"
        gradientTransform="matrix(-1 0 0 1 -756.33 -272.88)"
        xlinkHref="#s-5a64174af5-c"
      />
      <linearGradient
        id="s-5a64174af5-ae"
        x1="-1072.55"
        x2="-1055.85"
        y1="407.77"
        y2="407.77"
        gradientTransform="matrix(-1 0 0 1 -756.33 -272.88)"
        xlinkHref="#s-5a64174af5-c"
      />
      <linearGradient
        id="s-5a64174af5-af"
        x1="636.59"
        x2="647.04"
        y1="388.73"
        y2="388.73"
        xlinkHref="#s-5a64174af5-c"
      />
      <linearGradient
        id="s-5a64174af5-ag"
        x1="643.11"
        x2="653.27"
        y1="407.33"
        y2="407.33"
        xlinkHref="#s-5a64174af5-c"
      />
      <linearGradient
        id="s-5a64174af5-ah"
        x1="636.43"
        x2="643.43"
        y1="398.48"
        y2="398.48"
        xlinkHref="#s-5a64174af5-c"
      />
    </defs>
    <g id="surface">
      <g id="mainSurface">
        <path
          d="M341.31 192.14L1.64 167.64l135.34-79.17L307.64 98.8l33.67 93.34z"
          style={{
            fill: "#4d4d4d",
            stroke: "#fff",
            strokeMiterlimit: "10",
          }}
        />
        <path
          d="M326.54 182.34L29.27 160.85l110.95-66.21 160.39 9.91 25.93 77.79z"
          style={{
            stroke: "#fff",
            strokeMiterlimit: "10",
          }}
        />
        <path
          d="M162.33 179.23l57.86-85.85"
          style={{
            fill: "none",
            stroke: "#fff",
            strokeMiterlimit: "10",
          }}
        />
      </g>
      <path
        id="surfaceBasket"
        className="basketball"
        d="M229.34 120.67l-55.33-2.8 15.71-19.89 50.5 2.85-10.88 19.84z"
      />
    </g>
    <g id="lines" className="basketball">
      <g id="basketballLines" className="basketball">
        <path
          d="M477 368.15c-40.49 38.34 153.72 47.59 160.37 9"
          style={{
            fill: "none",
            stroke: "#fff",
            strokeMiterlimit: "10",
          }}
          transform="translate(-337.39 -272.88)"
        />
        <path
          d="M229.34 120.67l-55.33-2.8 15.71-19.89 50.5 2.85-10.88 19.84z"
          style={{
            fill: "none",
            stroke: "#fff",
            strokeMiterlimit: "10",
          }}
        />
        <path
          d="M566.72 393.55c-3.76 4.7-14 8-27.48 7.82-15.38-.25-30.25-3.87-27.85-10.8"
          style={{
            fill: "none",
            stroke: "#fff",
            strokeMiterlimit: "10",
          }}
          transform="translate(-337.39 -272.88)"
        />
      </g>
    </g>
    <image
      id="high"
      width="1348"
      height="791"
      transform="translate(16.85) scale(.24)"
      xlinkHref={_12x101}
    />
    <image
      id="medium"
      width="1357"
      height="733"
      transform="matrix(.24 0 0 .24 16.85 16.56)"
      xlinkHref={_12x102}
    />
    <image
      id="small"
      width="1404"
      height="684"
      transform="matrix(.24 0 0 .24 5.57 28.56)"
      xlinkHref={_12x103}
    />
    <g id="wicket">
      <path
        d="M168.12 90.66l-18.1-1.03V51.19l18.1 1.05v38.42z"
        style={{
          fill: "#fff",
        }}
      />
      <path
        d="M167.9 62.36l-.85-.07v-3.36l.85.06v3.37zM167.9 83.66l-.85-.07v-3.37l.85.07v3.37z"
        style={{
          fill: "#999",
        }}
      />
      <path
        d="M167.05 53.72v36.33"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-5a64174af5-a)",
        }}
      />
      <path
        d="M165.86 53.65v36.36"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-5a64174af5-d)",
        }}
      />
      <path
        d="M164.75 53.6v36.35"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-5a64174af5-e)",
        }}
      />
      <path
        d="M163.64 53.48V89.9"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-5a64174af5-f)",
        }}
      />
      <path
        d="M162.45 53.42v36.41"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-5a64174af5-g)",
        }}
      />
      <path
        d="M161.34 53.35v36.41"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-5a64174af5-h)",
        }}
      />
      <path
        d="M160.21 53.29v36.4"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-5a64174af5-i)",
        }}
      />
      <path
        d="M159.02 53.21v36.42"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-5a64174af5-j)",
        }}
      />
      <path
        d="M157.91 53.14v36.42"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-5a64174af5-k)",
        }}
      />
      <path
        d="M156.8 53.08v36.43"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-5a64174af5-l)",
        }}
      />
      <path
        d="M155.61 53.08v36.34"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-5a64174af5-m)",
        }}
      />
      <path
        d="M154.5 52.93v36.4"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-5a64174af5-n)",
        }}
      />
      <path
        d="M153.43 52.89v36.34"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-5a64174af5-o)",
        }}
      />
      <path
        d="M152.24 52.84v36.39"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-5a64174af5-p)",
        }}
      />
      <path
        d="M151.13 52.76v36.41"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-5a64174af5-q)",
        }}
      />
      <path
        d="M167.05 59.32l-15.92-.93"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-5a64174af5-r)",
        }}
      />
      <path
        d="M167.05 57.87l-15.92-.94"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-5a64174af5-s)",
        }}
      />
      <path
        d="M167.05 56.49l-15.92-.93"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-5a64174af5-t)",
        }}
      />
      <path
        d="M167.05 55.04l-15.92-.93"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-5a64174af5-u)",
        }}
      />
      <path
        d="M167.05 53.66l-15.92-.93"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-5a64174af5-v)",
        }}
      />
      <path
        d="M167.05 88.95l-15.92-.94"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-5a64174af5-w)",
        }}
      />
      <path
        d="M167.05 90.15l-15.92-.94"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-5a64174af5-x)",
        }}
      />
      <path
        d="M167.05 87.57l-15.92-.94"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-5a64174af5-y)",
        }}
      />
      <path
        d="M167.05 86.12l-15.92-.94"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-5a64174af5-z)",
        }}
      />
      <path
        d="M167.05 84.74l-15.92-.94"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-5a64174af5-A)",
        }}
      />
      <path
        d="M167.05 83.29l-15.92-.94"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-5a64174af5-B)",
        }}
      />
      <path
        d="M167.05 81.91l-15.92-.94"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-5a64174af5-C)",
        }}
      />
      <path
        d="M167.05 80.46l-15.92-.94"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-5a64174af5-D)",
        }}
      />
      <path
        d="M167.05 79.08l-15.92-.93"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-5a64174af5-E)",
        }}
      />
      <path
        d="M167.05 77.63l-15.92-.94"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-5a64174af5-F)",
        }}
      />
      <path
        d="M167.05 76.22l-15.92-.94"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-5a64174af5-G)",
        }}
      />
      <path
        d="M167.05 74.77l-15.92-.94"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-5a64174af5-H)",
        }}
      />
      <path
        d="M167.05 73.39l-15.92-.94"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-5a64174af5-I)",
        }}
      />
      <path
        d="M167.05 71.94L151.13 71"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-5a64174af5-J)",
        }}
      />
      <path
        d="M167.05 70.56l-15.92-.94"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-5a64174af5-K)",
        }}
      />
      <path
        d="M167.05 69.11l-15.92-.94"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-5a64174af5-L)",
        }}
      />
      <path
        d="M167.05 67.73l-15.92-.94"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-5a64174af5-M)",
        }}
      />
      <path
        d="M167.05 66.28l-15.92-.94"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-5a64174af5-N)",
        }}
      />
      <path
        d="M167.05 64.9l-15.92-.94"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-5a64174af5-O)",
        }}
      />
      <path
        d="M167.05 63.45l-15.92-.94"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-5a64174af5-P)",
        }}
      />
      <path
        d="M167.05 62.07l-15.92-.94"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-5a64174af5-Q)",
        }}
      />
      <path
        d="M167.05 60.62l-15.92-.94"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".25px",
          stroke: "url(#s-5a64174af5-R)",
        }}
      />
      <path
        d="M150.02 89.43V51.25l18.1 1.05v38.18"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          stroke: "url(#s-5a64174af5-S)",
        }}
      />
      <circle
        cx="152.93"
        cy="67.61"
        r="1.36"
        style={{
          fill: "url(#s-5a64174af5-T)",
        }}
      />
      <path
        d="M152.93 67.61l3.46.16"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".5px",
          stroke: "url(#s-5a64174af5-U)",
        }}
      />
    </g>
    <g id="basketballAcross">
      <path
        d="M216.46 99.9l-2.09-.12V54.93l2.09-.02V99.9z"
        style={{
          fill: "#666",
        }}
      />
      <path
        d="M216.46 99.9l1.04-.58V54.58l-1.04.33V99.9z"
        style={{
          fill: "#333",
        }}
      />
      <path
        d="M217.5 54.58l-1.04.33-2.67.01 1.86-.41 1.85.07z"
        style={{
          fill: "#858589",
        }}
      />
      <path
        d="M216.19 71.24l-1.82-.14-3.22-14.24 1.82.15 3.22 14.23z"
        style={{
          fill: "#4d4d4d",
        }}
      />
      <path
        d="M216.19 66.61l.01 4.63-3.22-14.23h-2.02l.97-1.01h1.86l2.4 10.61z"
        style={{
          fill: "#333",
        }}
      />
      <path
        d="M562.55 321.46c-1.4-4.76-6.45-8.29-12.49-8.29s-10.46 2.14-11.86 6.91v6.08l5.86 6.18 12.15.71 6.29-5.49v-.07z"
        style={{
          fill: "#fff",
        }}
        transform="translate(-337.39 -272.88)"
      />
      <path
        d="M556.27 333.13l-12.22-.71-5.91-6.25v-6.1c1.34-4.56 5.47-7 11.94-7 6 0 11.12 3.44 12.57 8.35v6.17zm-12.14-.88l12.08.7 6.25-5.45v-6c-1.44-4.84-6.54-8.22-12.41-8.22-6.38 0-10.45 2.37-11.77 6.84v6z"
        style={{
          fill: "#1a1a1a",
        }}
        transform="translate(-337.39 -272.88)"
      />
      <path
        d="M555.68 332.51l-11.39-.66-5.54-5.85V320.24c1.26-4.28 5.12-6.54 11.16-6.54 5.56 0 10.39 3.21 11.75 7.82V327.33l-.08.12zm-11.16-1.16l11 .64 5.64-4.86v-5.51c-1.31-4.36-5.93-7.41-11.25-7.41-4 0-9.15 1.07-10.66 6.14v5.48z"
        style={{
          fill: "#1a1a1a",
        }}
        transform="translate(-337.39 -272.88)"
      />
      <path
        d="M213.46 59.33l-2.47-.15v-2.33l2.47.13v2.35z"
        style={{
          fill: "#c1272d",
        }}
      />
      <path
        d="M554.37 330.3l-9.16-.5v-7.59l9.16.5zm-8.55-1.09l7.93.44v-6.35l-7.93-.44z"
        style={{
          fill: "#1a1a1a",
        }}
        transform="translate(-337.39 -272.88)"
      />
      <path
        d="M549.89 330.66a2.9 2.9 0 0 0-1.16-.25 4.13 4.13 0 0 0-1.36.08l1-.76 2.48.13z"
        style={{
          fill: "#ea371f",
        }}
        transform="translate(-337.39 -272.88)"
      />
      <path
        d="M549.27 331.77l-5.78.24a.13.13 0 0 1-.16-.09.12.12 0 0 1 .08-.15l5.78-.24a.13.13 0 0 1 .16.09.12.12 0 0 1-.08.15z"
        style={{
          fill: "url(#s-5a64174af5-V)",
        }}
        transform="translate(-337.39 -272.88)"
      />
      <path
        d="M551.93 332.27a.22.22 0 0 1 0 .14c0 .07-.11.07-.17 0l-2.06-.63a.23.23 0 0 1 0-.24c0-.07.11-.07.16 0l2.07.63z"
        style={{
          fill: "url(#s-5a64174af5-W)",
        }}
        transform="translate(-337.39 -272.88)"
      />
      <path
        d="M543.85 334.09a4.56 4.56 0 0 1-.14-.64l-.18-.12c.1.26.21.51.32.76zM544.55 334.28c.12.25.24.5.38.74a5.09 5.09 0 0 1-.41-1.17l-.14-.05c.05.2.11.32.17.48zM548.89 336.35c.18-.19.35-.39.52-.59a9.23 9.23 0 0 0-.19-1.05v-.1c-.19.29-.4.57-.61.85l.21.61c0 .07.03.17.07.28zM545.39 332.85l.24.92a5 5 0 0 0 .58.09c0-.66 0-1.33.1-2a3.2 3.2 0 0 1 .13-1.06 7.83 7.83 0 0 0-1.61.37 3.81 3.81 0 0 1 .56 1.68zM545 335a5.93 5.93 0 0 0 .82 1.16 2.81 2.81 0 0 0 .1-.31c0-.12.06-.24.08-.37-.13-.32-.24-.65-.34-1a2.92 2.92 0 0 1-.24-.37 7.73 7.73 0 0 1-.8-.21 4.21 4.21 0 0 0 .38 1.1zM549.28 334.44a6.22 6.22 0 0 1 .25 1.17v-.06c.07-.52.11-1 .13-1.54h-.17zM547.25 333.07c0-.29-.07-.58-.11-.87a4.43 4.43 0 0 0-.16-1c0-.08-.11-.25-.19-.27s-.23.18-.26.32a4.43 4.43 0 0 0-.09.9c0 .54 0 1.14-.07 1.76h1c-.06-.27-.09-.56-.12-.84zM547.49 334.28v.23l.09-.23h-.11zM549.75 335.31c.14-.21.27-.43.39-.65a5.29 5.29 0 0 0 .06-.8l-.35.11c-.02.44-.05.89-.1 1.34zM549.21 334.24l.09-.16h-.12a.59.59 0 0 1 .03.16zM547.37 334.75v-.47H547zM545.8 334.39c.11.13.22.27.32.41 0-.19 0-.39.06-.58l-.45-.06a1.55 1.55 0 0 1 .07.23zM546.27 335l.32.42c.09.13.19.25.29.38l.35-.71c0-.05 0-.09.07-.13a6.8 6.8 0 0 1-.38-.7h-.57c-.02.23-.04.49-.08.74zM547.52 334.82a1.28 1.28 0 0 0 0 .19c.17.29.33.59.49.88.14-.17.27-.35.41-.53q-.2-.54-.36-1.11h-.32c-.06.2-.14.39-.22.57zM550.33 334.15c0-.13.09-.25.13-.38h-.12c0 .15 0 .23-.01.38zM548.51 335.25c.22-.28.42-.57.62-.86a1.29 1.29 0 0 1-.06-.25c-.3.05-.6.08-.92.11.13.33.25.66.36 1zM549.15 333.76l.43-.09c.11-.19.21-.38.31-.57a13.31 13.31 0 0 1 .84-1.84 6.31 6.31 0 0 0-1.69-.45v.24c.12.95.02 1.81.11 2.71zM551.69 332.23c0-.3-.27-.6-.72-.85a7.81 7.81 0 0 1-.23 1.88c.61-.26.96-.68.95-1.03zM544.12 334.61c.18.33.38.65.59 1v.11c.22.32.46.64.7.95l.09.12.15-.33a8.73 8.73 0 0 1-1-1.38 8.17 8.17 0 0 1-.55-1.3l-.31-.16a10.52 10.52 0 0 0 .33.99zM543.81 333.09l.25.17c-.12-.39-.23-.78-.32-1.18a5.65 5.65 0 0 0 .07 1.01z"
        style={{
          fill: "none",
        }}
        transform="translate(-337.39 -272.88)"
      />
      <path
        d="M547.47 333.92h.27c.08-.21.14-.42.2-.64.15-.56.24-1.12.4-1.67a3.39 3.39 0 0 1 .3-.83 10.58 10.58 0 0 0-1.15 0h-.57a3.78 3.78 0 0 1 .4 1.61c.06.49.11 1.01.15 1.53zM549 331.7a3.58 3.58 0 0 0 0-.73c-.09-.34-.15-.05-.22.1s-.11.28-.16.42c-.16.49-.25 1-.37 1.51a6.69 6.69 0 0 1-.27.9 9.38 9.38 0 0 0 1.12-.12 17.93 17.93 0 0 1-.1-2.08zM544.45 333.44a7.61 7.61 0 0 1 0-2.13 3.24 3.24 0 0 0-.7.42c.13.54.28 1.08.45 1.61zM550 335.94c.15-.3.29-.6.41-.91a10.14 10.14 0 0 0 .33-1.37h-.09a4.7 4.7 0 0 1-.35.93 8.29 8.29 0 0 1-.3 1.35z"
        style={{
          fill: "none",
        }}
        transform="translate(-337.39 -272.88)"
      />
      <path
        d="M208.18 61.25z"
        style={{
          fill: "none",
        }}
      />
      <path
        d="M550.63 334.71c0 .15-.09.3-.14.45a8.94 8.94 0 0 0 .9-1.87 3.16 3.16 0 0 1-.41.24 10 10 0 0 1-.35 1.18zM550.85 331.32a6.15 6.15 0 0 0-.44 1 10.45 10.45 0 0 1-.56 1.17l-.06.1a5.69 5.69 0 0 0 .8-.28 7.65 7.65 0 0 0 .26-1.99zM547.06 337l.29-.34-.46-.63c-.07.13-.14.27-.22.4a5.72 5.72 0 0 0 .39.57zM549.71 335.57c0 .25-.07.51-.11.76l.19-.19c.11-.37.21-.75.29-1.13-.08.19-.24.38-.37.56zM548.94 336.49c0 .12.09.25.14.38l.34-.36a.5.5 0 0 0 0-.12v-.45c-.15.19-.31.37-.48.55zM544.49 332.44a7.17 7.17 0 0 0 .07 1 4.91 4.91 0 0 0 .91.27c-.14-.54-.26-1.07-.39-1.6 0-.13-.16-.81-.36-.94l-.16.07a4.74 4.74 0 0 0 0 .69c-.06.2-.07.36-.07.51zM547.53 335.36v1.12l.39-.48c-.12-.21-.25-.43-.39-.64zM546.81 335.94l-.34-.44c-.07-.1-.15-.19-.23-.29v.3a7.12 7.12 0 0 0 .41.83zM543.64 331.86a.76.76 0 0 0-.27.56.78.78 0 0 0 .27.53 7.93 7.93 0 0 1 0-1.09zM547.38 335.11c-.13.27-.27.53-.41.8l.42.57q.01-.68-.01-1.37zM548.49 336.76l.31-.31c0-.13-.08-.25-.13-.38l-.18-.53-.39.5c0 .07.07.13.1.2zM546.09 335l-.15-.19.12.36zM546.51 336.49l-.12-.21c-.09-.17-.17-.35-.25-.53 0 .18-.1.36-.16.54l.4.42a2.53 2.53 0 0 0 .13-.22zM545.79 336.26a7.28 7.28 0 0 1-.44-.57 5.9 5.9 0 0 0 .43.59z"
        style={{
          fill: "none",
        }}
        transform="translate(-337.39 -272.88)"
      />
      <path
        d="M544.45 333.44h.11a7.17 7.17 0 0 1-.07-1v-.47a4.74 4.74 0 0 1 0-.69h-.08a7.61 7.61 0 0 0 .04 2.16zM546.21 333.86h.16c0-.62 0-1.22.07-1.76a4.43 4.43 0 0 1 .09-.9c0-.14.09-.37.26-.32s.16.19.19.27a4.43 4.43 0 0 1 .16 1c0 .29.08.58.11.87s.06.57.08.85h.14c0-.52-.09-1-.15-1.55a3.78 3.78 0 0 0-.4-1.61l-.48.05a3.2 3.2 0 0 0-.13 1.06c-.05.71-.06 1.38-.1 2.04zM543.81 333.09a5.65 5.65 0 0 1-.07-1c.09.4.2.79.32 1.18l.17.08c-.17-.53-.32-1.07-.45-1.61a.86.86 0 0 0-.14.13 7.93 7.93 0 0 0 0 1.09zM544.55 330.9a.18.18 0 0 0-.11 0h.12zM545.08 332.15c.13.53.25 1.06.39 1.6h.16l-.24-.92a3.81 3.81 0 0 0-.56-1.67h-.11c.2.18.33.84.36.99z"
        style={{
          fill: "#fff",
        }}
        transform="translate(-337.39 -272.88)"
      />
      <path
        d="M550.49 335.16c0-.15.1-.3.14-.45a10 10 0 0 0 .34-1.15l-.26.13a10.14 10.14 0 0 1-.33 1.37c-.12.31-.26.61-.41.91a8.29 8.29 0 0 0 .3-1.31 4.7 4.7 0 0 0 .35-.93l-.17.07c0 .13-.08.25-.13.38v-.34l-.14.05a5.29 5.29 0 0 1-.06.8c-.12.22-.25.44-.39.65 0-.45.08-.9.1-1.34h-.15c0 .51-.06 1-.13 1.54v.06a6.22 6.22 0 0 0-.25-1.17l.25-.4h-.22l-.09.16a.59.59 0 0 0 0-.13h-.12a1.29 1.29 0 0 0 .06.25c-.2.29-.4.58-.62.86-.11-.34-.23-.67-.36-1h-.08q.16.57.36 1.11c-.14.18-.27.36-.41.53-.16-.29-.32-.59-.49-.88a1.28 1.28 0 0 1 0-.19c.08-.18.16-.37.23-.55h-.15l-.09.23v-.23h-.14v.47l-.34-.48h-.11a6.8 6.8 0 0 0 .38.7s0 .08-.07.13l-.35.71c-.1-.13-.2-.25-.29-.38l-.32-.42c0-.26.06-.52.08-.78h-.17c0 .19 0 .39-.06.58-.1-.14-.21-.28-.32-.41a1.55 1.55 0 0 0-.07-.23H545.49a2.92 2.92 0 0 0 .24.37c.1.33.21.66.34 1 0 .13 0 .25-.08.37a2.81 2.81 0 0 1-.1.31A5.93 5.93 0 0 1 545 335a4.21 4.21 0 0 1-.38-1.08h-.11a5.09 5.09 0 0 0 .41 1.17c-.14-.24-.26-.49-.38-.74s-.12-.32-.17-.48l-.19-.08a8.17 8.17 0 0 0 .55 1.3 8.73 8.73 0 0 0 1 1.38l-.15.33-.09-.12c-.24-.31-.48-.63-.7-.95v-.11c-.21-.32-.41-.64-.59-1a10.52 10.52 0 0 1-.24-1.05l-.17-.11a4.56 4.56 0 0 0 .14.64c-.11-.25-.22-.5-.32-.76a.86.86 0 0 1-.14-.13 9.38 9.38 0 0 0 1.38 2.71c.11.36.22.72.35 1.07a3.88 3.88 0 0 0 0 .59 11.12 11.12 0 0 1-.09 1.53v.35c-.08.4-.29 1.56.26 1.16a.71.71 0 0 0 .31.24.46.46 0 0 0 .48-.16c.13.23.31.45.54.43a.5.5 0 0 0 .35-.25l.08-.12a.6.6 0 0 0 .86.15 1.08 1.08 0 0 0 .27-.29.73.73 0 0 0 .17.18c.33.23.48-.14.54-.41a.29.29 0 0 0 0-.09l.17.31a.07.07 0 0 0 .13 0 6.43 6.43 0 0 0 .09-1.7 4.47 4.47 0 0 1 .08-.82v-.06a8 8 0 0 1 .2-.81.75.75 0 0 1 .07-.12c.19-.36.36-.73.52-1.1v-.05-.11a10.56 10.56 0 0 0 1.31-2.65l-.2.17a8.94 8.94 0 0 1-.85 1.8zm-1.31-.58v.1a9.23 9.23 0 0 1 .19 1.05c-.17.2-.34.4-.52.59 0-.11-.07-.21-.11-.31l-.21-.61c.25-.25.47-.53.65-.82zm-3.87 2.89c.06.16.13.32.2.48l-.19.22c0-.21-.06-.41-.09-.62zm-.09 0v-.27c0-.09 0 .12.07.19zm.36.63c.06.14.13.29.2.43l-.3.37c-.05-.19-.1-.39-.14-.59zm1.54-.41l-.19-.18zm-.09-.3l.06-.08c.12.15.25.29.38.44l-.07.06c-.12-.15-.24-.3-.4-.43zm.2.58l-.4.39-.31-.38.32-.37zm-.34-.73l-.41-.42.11-.19a6.28 6.28 0 0 0 .38.52zm-.1.11a.6.6 0 0 1-.08-.08l-.31-.3c.14.1.27.23.39.37zm-.1.12l-.3.34-.29-.36.22-.34zm-.38.44l-.43.51-.21-.43a3.65 3.65 0 0 0 .35-.43zm-.43.8c.07.15.15.29.23.43l-.12.14c-.09.11-.18.23-.26.35-.08-.18-.14-.36-.2-.54zm.15 0l-.06-.11c.16-.18.32-.35.47-.53l.3.37c-.19.19-.37.38-.54.58zm.8-.15l.37.48-.23.27c-.11.15-.23.29-.34.43-.12-.19-.24-.39-.35-.59.17-.15.36-.4.55-.59zm.08-.09l.26-.26.16-.16.38.38-.43.51c-.12-.16-.28-.32-.37-.47zm1.47-.52l.35-.39c.06.14.13.28.2.42l-.29.39c-.08-.14-.17-.28-.26-.37zm.13.59l-.09.12-.33-.39.17-.18zm-.24-.77c-.08-.13-.17-.25-.25-.37.14-.14.28-.28.43-.41l.18.37zm-.12.13c-.06.08-.13.15-.19.22l-.31-.35.27-.25zm-.26.31l-.1.11-.06-.06c-.08-.12-.16-.24-.25-.35l.08-.07zm-.06.36c.11.13.21.26.31.4l-.1.12c-.12.14-.25.28-.37.43l-.06-.1c-.08-.12-.16-.23-.25-.34zm.23.05l-.14-.16.1-.1c.11.13.22.26.32.4l-.09.11c-.06-.09-.13-.17-.19-.25zm.36.24l.25.36a1.11 1.11 0 0 0-.07.16c-.08-.13-.18-.27-.27-.4zm.08-.09l.08-.11c.06.11.12.22.17.33v.1zm.21-.27l.28-.38v.06l-.18.56a.616.616 0 0 0-.1-.24zm.12-1.06l.22-.24c0 .13.09.26.13.39 0 .08-.1.17-.16.25-.02-.13-.12-.27-.19-.4zm-.1-.2l-.18-.35.29-.3c0 .13.09.26.13.39zm-.24-1.7l.18.53c.05.13.09.25.13.38l-.31.31-.29-.52c0-.07-.07-.13-.1-.2zm-.44.69q.18.31.33.63c-.14.15-.29.29-.44.43l-.3-.45-.09-.11.46-.57a.25.25 0 0 1 .04.07zm-.52-.87c.14.21.27.43.39.64l-.39.48c.01-.37.01-.75 0-1.12zm0 1.56c.11.15.21.31.31.47l-.16.15-.12.12-.37-.47c.1-.11.19-.23.28-.35zm-.55-1c.14-.27.28-.53.41-.8v1.38l-.42-.57zm-.08.15l.46.63-.29.34a5.72 5.72 0 0 1-.39-.57c.07-.14.14-.28.21-.41zm-.65-.85c.08.1.16.19.23.29l.34.44-.21.4a7.12 7.12 0 0 1-.41-.83c.01-.11.03-.21.04-.31zm-.3-.38l.15.19v.17zm.2.92c.08.18.16.36.25.53l.12.21a2.53 2.53 0 0 1-.13.22l-.4-.42c.01-.19.1-.37.15-.55zm-.21.67c.12.14.25.28.38.41a5.14 5.14 0 0 1-.38-.42zm-.58-.73c.13.19.28.38.44.57a5.9 5.9 0 0 1-.45-.58zm.5.91l.36.39-.21.33-.31-.4a3.18 3.18 0 0 0 .15-.33zm-.23.44l.3.38c-.1.15-.2.28-.31.42l-.21-.48a3.62 3.62 0 0 0 .21-.37zm-.67-.88c.18.25.37.5.56.74 0 .11-.11.22-.16.32-.15-.36-.28-.71-.36-1.07zm.27 2.28c0 .19.09.39.15.59s-.15.2-.23.3c0-.34.05-.61.07-.9zm-.19 1.47a1.68 1.68 0 0 0 .09.32c-.13-.11-.13-.14-.13-.33zm.28.39a1.59 1.59 0 0 1-.15-.5v-.31l.29-.3a5.37 5.37 0 0 0 .21.56c-.09.13-.17.26-.25.39a.73.73 0 0 1-.11.15zm.1.13c.05-.1.09-.2.14-.29l.16-.24c.06.14.13.28.2.41l.1.2c-.15.12-.33.17-.61-.09zm.54-.32c-.06-.11-.11-.22-.16-.33.1-.14.2-.28.31-.41l.08-.1.34.61-.27.34-.14.18zm.64.6c-.29 0-.31 0-.4-.17l.07-.08c.11-.15.23-.29.34-.43a5.07 5.07 0 0 0 .36.54c-.09.13-.08.13-.38.13zm.44-.27c-.09-.14-.16-.29-.22-.39a1.4 1.4 0 0 0-.1-.16l.59-.71.09.12.22.32c-.14.18-.28.36-.41.55s-.13.17-.21.26zm1.09 0a.65.65 0 0 1-.81.3.7.7 0 0 1-.18-.17c.14-.21.26-.43.42-.64l.15-.2.27.4.16.3zm.07-.14a5.29 5.29 0 0 1-.41-.66l.46-.57c.1.14.2.3.3.45-.09.22-.18.43-.28.64zm.66-.14c0 .11 0 .22-.07.33-.23.11-.4.1-.49 0a5 5 0 0 0 .33-.8c.08.14.17.29.24.43a.17.17 0 0 1-.02.05zm0-.3a3.35 3.35 0 0 0-.21-.36l.06-.15c.06.1.11.21.17.32zm0-.43l-.13-.23v-.09l.11.21s.09.09.09.12zm0-.56l.06-.17v.26zm.24 1.47l-.17-.3v-.16c0 .12.09.25.12.38zm0-.27a2.86 2.86 0 0 0-.15-.41v-.13l.16.31a2 2 0 0 1 .08.24zm0-1.44v.9c0-.11-.09-.22-.14-.33 0-.26 0-.53.08-.79l.06.14zm0-.33l-.06-.12c0-.13.06-.25.1-.37v.08c.14.15.11.29.1.42zm0-1l-.09-.26.2-.21c.11.16.07.35.03.51zm.11.34v-.1zm.07-1.18l-.34.36c-.05-.13-.1-.26-.14-.38.17-.18.33-.36.48-.55v.45a.5.5 0 0 1 .14.16zm.23.07v.06a.93.93 0 0 1 0 .1v-.11l.09-.11zm0-.25c0-.25.08-.51.11-.76s.26-.37.37-.56c-.08.38-.18.76-.29 1.13z"
        style={{
          fill: "#fff",
        }}
        transform="translate(-337.39 -272.88)"
      />
      <path
        d="M547.94 333.27c-.06.22-.12.43-.2.64h.15a6.69 6.69 0 0 0 .27-.9c.12-.51.21-1 .37-1.51.05-.14.1-.28.16-.42s.13-.44.22-.1a3.58 3.58 0 0 1 0 .73 17.93 17.93 0 0 0 .06 2.08h.14c-.09-.9 0-1.81-.08-2.71v-.24h-.4a3.39 3.39 0 0 0-.3.83c-.15.48-.24 1.04-.39 1.6zM549.58 333.67l.21-.06.06-.1a10.45 10.45 0 0 0 .56-1.17 6.15 6.15 0 0 1 .44-1 7.65 7.65 0 0 1-.26 2l.15-.07a7.81 7.81 0 0 0 .23-1.88l-.24-.12a13.31 13.31 0 0 0-.84 1.84c-.1.18-.2.37-.31.56zM551 331.28a.16.16 0 0 0 .11-.15.15.15 0 0 0-.16-.14.15.15 0 0 0-.15.15.08.08 0 0 0 0 .05l-.06.07.24.12zM546.81 330.65a.18.18 0 0 0-.35 0 .26.26 0 0 0 0 .08.2.2 0 0 0-.09.11l.52-.05a.38.38 0 0 0-.08-.14zM549.19 330.67a.17.17 0 0 0 0-.14.18.18 0 0 0-.21-.09c-.05 0-.11.06-.11.11a.27.27 0 0 0 0 .09l-.08.1.44.05a.5.5 0 0 0-.04-.12zM544.5 331.18a.59.59 0 0 0 0 .13h.08a.21.21 0 0 1 0-.07.13.13 0 0 1 .12 0h.11l-.13-.13a.14.14 0 0 0-.14-.15h-.12a.16.16 0 0 0 .08.22zM543.78 331.73v-.05a.13.13 0 0 0 0-.08.15.15 0 0 0-.15-.14.14.14 0 0 0-.14.14.13.13 0 0 0 .13.14v.12a.86.86 0 0 1 .16-.13z"
        style={{
          fill: "#fff",
        }}
        transform="translate(-337.39 -272.88)"
      />
      <path
        d="M544.6 331.21a.21.21 0 0 0 0 .07l.16-.07a.13.13 0 0 0-.16 0z"
        style={{
          fill: "url(#s-5a64174af5-b)",
        }}
        transform="translate(-337.39 -272.88)"
      />
      <path
        d="M547.48 330.37a8.7 8.7 0 0 0-2.92.53.14.14 0 0 1 .14.15l.13.13a7.83 7.83 0 0 1 1.61-.37.44.44 0 0 1 .08-.1.19.19 0 0 1 0-.07.17.17 0 0 1 .16-.16.16.16 0 0 1 .16.15v.05l.1.08h.57a10.58 10.58 0 0 1 1.15 0 .36.36 0 0 1 .07-.1.19.19 0 0 1 0-.08.15.15 0 0 1 .11-.11.17.17 0 0 1 .19.08.15.15 0 0 1 0 .13.42.42 0 0 1 0 .12 6.31 6.31 0 0 1 1.69.45l.06-.07a.08.08 0 0 1 0-.05.15.15 0 0 1 .15-.15.15.15 0 0 1 .16.14.16.16 0 0 1-.11.15v.1c.45.25.71.55.72.85s-.34.72-1 1l-.15.07a5.69 5.69 0 0 1-.8.28l-.21.06-.43.09h-.14a9.38 9.38 0 0 1-1.12.12h-1.72a5 5 0 0 1-.58-.09h-.16a4.91 4.91 0 0 1-.91-.27h-.11l-.22-.1-.17-.08-.25-.17-.17-.14a.78.78 0 0 1-.27-.53.76.76 0 0 1 .27-.56v-.12a.13.13 0 0 1-.13-.14.14.14 0 0 1 .14-.14.15.15 0 0 1 .15.14.13.13 0 0 1 0 .08v.05a3 3 0 0 1 .7-.42.59.59 0 0 1 0-.13.16.16 0 0 1-.06-.24c-.9.38-1.45.91-1.44 1.49a1.09 1.09 0 0 0 .39.77.86.86 0 0 0 .14.13l.18.12.17.11.31.16.19.08.14.05h.11a7.73 7.73 0 0 0 .8.21H545.65l.45.06h1.97c.32 0 .62-.06.92-.11h.78l.35-.11.14-.05h.12l.17-.07h.09l.26-.13a3.16 3.16 0 0 0 .41-.24l.2-.17a1.24 1.24 0 0 0 .47-.9c.02-1.25-1.98-2.07-4.5-2.01z"
        style={{
          fill: "url(#s-5a64174af5-X)",
        }}
        transform="translate(-337.39 -272.88)"
      />
    </g>
    <g id="unihockey">
      <g id="unihockeyLeft">
        <path
          d="M117.6 137.68l-44.43-2.59 41.58-26.27 40.87 2.72-38.02 26.14z"
          style={{
            fill: "none",
            stroke: "#fff",
            strokeMiterlimit: "10",
          }}
        />
        <path
          d="M434.41 401l-11.91-.75v-1.09l20.86-12.44a3 3 0 0 1 2-.41l9.5 1.29v1.09l-9.22-.58a3.14 3.14 0 0 0-1.81.45l-16.69 10.12 7.26 1.23z"
          style={{
            fill: "url(#s-5a64174af5-c)",
          }}
          transform="translate(-337.39 -272.88)"
        />
        <path
          d="M434.26 399.86l-11.76-.75 21-12.51a3.13 3.13 0 0 1 1.79-.43l10.11.64-.44.58a.4.4 0 0 1-.34.15l-9.14-.58a3.13 3.13 0 0 0-1.79.43l-18.6 11.1 10.39.66-.93.64a.43.43 0 0 1-.29.07z"
          style={{
            fill: "url(#s-5a64174af5-Y)",
          }}
          transform="translate(-337.39 -272.88)"
        />
        <path
          d="M454.19 367.45a26 26 0 0 1-5.79-.58v-.11a26.79 26.79 0 0 0 6.25.58v.11zM454.14 366.87a23.66 23.66 0 0 1-5.49-.56v-.11a24.68 24.68 0 0 0 6 .56v.11zM454.24 368.61a28.46 28.46 0 0 1-6.07-.6v-.11a28.08 28.08 0 0 0 6.47.6v.11zM454.22 368a27.23 27.23 0 0 1-5.93-.59v-.11a27.19 27.19 0 0 0 6.36.59v.11zM454.16 369.66a29.3 29.3 0 0 1-6.14-.58v-.11a29 29 0 0 0 6.63.58v.11zM454.25 369.08a28.69 28.69 0 0 1-6.17-.61v-.11a28.86 28.86 0 0 0 6.56.61v.11zM454.2 370.83a31.43 31.43 0 0 1-6.46-.61v-.11a32 32 0 0 0 6.91.61v.1zM454.16 370.25a30.22 30.22 0 0 1-6.31-.59v-.1a31.1 31.1 0 0 0 6.8.57v.11zM454.25 372a33.9 33.9 0 0 1-6.73-.63v-.1a35.46 35.46 0 0 0 7.13.62v.11zM454.31 371.41a33 33 0 0 1-6.67-.68v-.11a32.79 32.79 0 0 0 7 .68v.11zM454.1 373.15a35.82 35.82 0 0 1-6.8-.58v-.11a35.41 35.41 0 0 0 7.35.58v.11zM454.27 372.57a35.26 35.26 0 0 1-6.87-.64v-.1a36 36 0 0 0 7.25.63v.11zM454.16 374.2a37.68 37.68 0 0 1-7.08-.6v-.1a39.09 39.09 0 0 0 7.57.59v.11zM454.12 373.62a36.3 36.3 0 0 1-6.93-.59v-.11a37.13 37.13 0 0 0 7.46.59v.11zM454.35 375.37a40.58 40.58 0 0 1-7.48-.74v-.11a40.88 40.88 0 0 0 7.78.74v.1zM454.18 374.79a40 40 0 0 1-7.22-.61v-.11a39.54 39.54 0 0 0 7.69.6v.11zM454.31 376a41.59 41.59 0 0 1-7.56-.71v-.11a41.72 41.72 0 0 0 7.9.71v.11zM454.24 377.11a45.44 45.44 0 0 1-7.73-.64v-.11a45.25 45.25 0 0 0 8.14.64v.11zM454.32 376.53a43.3 43.3 0 0 1-7.68-.71v-.11a43.34 43.34 0 0 0 8 .71v.11zM454.08 378.27a46.73 46.73 0 0 1-7.8-.59v-.11a46.9 46.9 0 0 0 8.38.59v.11zM454 377.69a44.79 44.79 0 0 1-7.61-.58V377a44.29 44.29 0 0 0 8.23.58v.11zM454.12 379.44a49.85 49.85 0 0 1-8.07-.61v-.11a50.37 50.37 0 0 0 8.6.61v.1zM454.1 378.86a48.43 48.43 0 0 1-7.94-.6v-.11a48.17 48.17 0 0 0 8.49.59v.11zM454.13 380.49a52.31 52.31 0 0 1-8.28-.62v-.11a52.88 52.88 0 0 0 8.81.62v.11zM454 379.91a49.33 49.33 0 0 1-8.09-.59v-.1a51.8 51.8 0 0 0 8.7.58v.1zM454 381.65a52.86 52.86 0 0 1-8.38-.58V381a54.57 54.57 0 0 0 9 .58v.11zM454.27 381.07a52.74 52.74 0 0 1-8.52-.71v-.11a52.87 52.87 0 0 0 8.9.71v.11zM454 382.81a55.73 55.73 0 0 1-8.61-.59v-.1a57.26 57.26 0 0 0 9.27.58v.11zM454 382.23a55.22 55.22 0 0 1-8.46-.58v-.11a54.55 54.55 0 0 0 9.14.58v.11zM454 384a58.77 58.77 0 0 1-8.87-.61v-.1a61.32 61.32 0 0 0 9.5.6v.1zM454 383.4a58.55 58.55 0 0 1-8.74-.6v-.11a58.61 58.61 0 0 0 9.38.59v.11zM454.08 385a62 62 0 0 1-9.13-.62v-.11a63.89 63.89 0 0 0 9.7.62v.11zM454.06 384.45a61.68 61.68 0 0 1-9-.61v-.11a62.55 62.55 0 0 0 9.59.61v.1zM454 386.19a64.61 64.61 0 0 1-9.25-.58v-.11a66.5 66.5 0 0 0 9.94.58v.11zM454 385.61a63.58 63.58 0 0 1-9.14-.58v-.11a64 64 0 0 0 9.82.58v.11z"
          style={{
            fill: "#fff",
          }}
          transform="translate(-337.39 -272.88)"
        />
        <path
          d="M108.06 113.69l-.11-.02 3.93-20.78.11.02-3.93 20.78zM108.95 113.69l-.11-.02 3.75-20.85.11.02-3.75 20.85zM115.96 114.23h-.11l.16-21.25h.11l-.16 21.25z"
          style={{
            fill: "#fff",
          }}
        />
        <path
          d="M442.11 376.35h21.2v.11h-21.2z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-89.4 145.72 410.383)"
        />
        <path
          d="M114.46 114.08l-.11-.01.44-21.1.11.01-.44 21.1zM111.82 113.92l-.11-.01 2.27-21.08.11.01-2.27 21.08z"
          style={{
            fill: "#fff",
          }}
        />
        <path
          d="M441.05 376.28h21v.11h-21z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-88.08 141.77 414.332)"
        />
        <path
          d="M439.14 376.14h21.11v.11h-21.11z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-82.95 126.685 430.592)"
        />
        <path
          d="M438.37 376.1h21.04v.11h-21.04z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-81.33 121.351 436.082)"
        />
        <path
          d="M112.88 113.92h-.11l1.45-21.09.11.01-1.45 21.08z"
          style={{
            fill: "#fff",
          }}
        />
        <path
          d="M444.83 386.62l-.61-.12 3.88-19.75a1.68 1.68 0 0 1 1.75-1.34l5.34.31v.62l-5.34-.31a1.06 1.06 0 0 0-1.1.84z"
          style={{
            fill: "url(#s-5a64174af5-Z)",
          }}
          transform="translate(-337.39 -272.88)"
        />
        <path
          d="M429.93 371.99h24.01v.08h-24.01z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.7 -219.466 853.127)"
        />
        <path
          d="M426.54 371.96h24.47v.08h-24.47z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.58 -229 852.616)"
        />
        <path
          d="M93.53 105.2l-.04-.07 20.53-12.33.04.07-20.53 12.33zM92.84 105.08l-.04-.07 20.27-12.17.04.07-20.27 12.17zM91.86 105.2l-.04-.07 20.6-12.33.04.07-20.6 12.33z"
          style={{
            fill: "#fff",
          }}
        />
        <path
          d="M450.41 364.53h.08v3.27h-.08z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-86.86 137.654 407.927)"
        />
        <path
          d="M449.52 365.31h.08v2.79h-.08z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-79.7 117.414 432.378)"
        />
        <path
          d="M112.8 94.55l-2.55-.63.02-.07 2.55.63-.02.07z"
          style={{
            fill: "#fff",
          }}
        />
        <path
          d="M448.26 366.28h.08v2.35h-.08z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-68.96 80.943 476.65)"
        />
        <path
          d="M447.64 366.65h.08V369h-.08z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-68.46 78.465 479.332)"
        />
        <path
          d="M431.68 375.49h.08v4.01h-.08z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-86 117.01 421.3)"
        />
        <path
          d="M432.44 375.16h.08v3.47h-.08z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-84.68 114.025 425.586)"
        />
        <path
          d="M433.35 374.75h.08v3.21h-.08z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-81.67 106.808 435.104)"
        />
        <path
          d="M434.18 374.3h.08v3.11h-.08z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-80.3 103.775 439.392)"
        />
        <path
          d="M106.1 98.6l-3.04-.43.01-.07 3.04.43-.01.07zM107 98.06l-3.02-.43.02-.08 3.01.43-.01.08z"
          style={{
            fill: "#fff",
          }}
        />
        <path
          d="M435.15 373.73h.08v3.09h-.08z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-80.34 104.89 438.679)"
        />
        <path
          d="M435.96 373.33h.08v2.94h-.08z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78 98.794 446.674)"
        />
        <path
          d="M436.77 372.79h.08v3.04h-.08z"
          style={{
            fill: "#fff",
          }}
          transform="matrix(.18 -.98 .98 .18 -345.64 465.89)"
        />
        <path
          d="M437.59 372.37h.08v2.91h-.08z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78 100.453 445.697)"
        />
        <path
          d="M102.4 100.83l-2.87-.57.01-.08 2.88.58-.02.07z"
          style={{
            fill: "#fff",
          }}
        />
        <path
          d="M439.22 371.33h.08v3.03h-.08z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-80.59 109.636 435.36)"
        />
        <path
          d="M446.48 366.93h.08v3.2h-.08z"
          style={{
            fill: "#fff",
          }}
          transform="matrix(.17 -.98 .98 .17 -331.05 471.73)"
        />
        <path
          d="M110.9 95.69l-2.44-.71.02-.07 2.44.71-.02.07zM109.81 96.36l-2.77-.54.02-.07 2.76.54-.01.07z"
          style={{
            fill: "#fff",
          }}
        />
        <path
          d="M445.03 367.97h.08v2.77h-.08z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-79.21 111.502 436.79)"
        />
        <path
          d="M444.34 368.4h.08v2.8h-.08z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.13 107.61 441.19)"
        />
        <path
          d="M443.67 368.8h.08v2.79h-.08z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-77.77 105.829 442.933)"
        />
        <path
          d="M441.28 370.15h.08v2.94h-.08z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-79.64 108.99 437.503)"
        />
        <path
          d="M104.58 99.52l-2.84-.57.02-.08 2.83.57-.01.08z"
          style={{
            fill: "#fff",
          }}
        />
        <path
          d="M439.95 371.04h.08v2.76h-.08z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-75.78 95.998 452.75)"
        />
        <path
          d="M422.16 391.71h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -231.15 869.413)"
        />
        <path
          d="M422.19 391.13h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -231.127 868.832)"
        />
        <path
          d="M422.34 390.51h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -230.957 868.213)"
        />
        <path
          d="M422.53 389.97h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -230.789 867.672)"
        />
        <path
          d="M422.56 389.39h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -230.743 867.078)"
        />
        <path
          d="M422.71 388.77h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -230.596 866.472)"
        />
        <path
          d="M422.77 388.27h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -230.534 865.96)"
        />
        <path
          d="M422.99 387.75h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -230.316 865.453)"
        />
        <path
          d="M423.02 387.17h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -230.289 864.854)"
        />
        <path
          d="M423.18 386.55h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -230.124 864.253)"
        />
        <path
          d="M423.36 386.01h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -229.95 863.694)"
        />
        <path
          d="M423.39 385.42h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -229.91 863.118)"
        />
        <path
          d="M423.54 384.81h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -229.763 862.512)"
        />
        <path
          d="M423.6 384.31h24.27v.11H423.6z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -229.7 862)"
        />
        <path
          d="M423.7 383.74h24.27v.11H423.7z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -229.605 861.44)"
        />
        <path
          d="M423.73 383.16H448v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -229.565 860.863)"
        />
        <path
          d="M423.89 382.54h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -229.413 860.24)"
        />
        <path
          d="M424.07 382h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -229.226 859.704)"
        />
        <path
          d="M424.1 381.42h24.27v.11H424.1z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -229.204 859.122)"
        />
        <path
          d="M424.26 380.8h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -229.052 858.499)"
        />
        <path
          d="M424.32 380.3h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -228.995 858.005)"
        />
        <path
          d="M424.5 379.63h24.27v.11H424.5z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -228.81 857.332)"
        />
        <path
          d="M424.65 379.02h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -228.658 856.708)"
        />
        <path
          d="M424.83 378.47h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -228.472 856.172)"
        />
        <path
          d="M424.86 377.89h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -228.45 855.59)"
        />
        <path
          d="M425.02 377.27h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -228.28 854.972)"
        />
        <path
          d="M425.08 376.78h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -228.222 854.479)"
        />
        <path
          d="M425.18 376.21h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -228.127 853.918)"
        />
        <path
          d="M425.21 375.63h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -228.099 853.318)"
        />
        <path
          d="M425.36 375.01h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -227.952 852.713)"
        />
        <path
          d="M425.55 374.47h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -227.76 852.159)"
        />
        <path
          d="M425.58 373.89h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -227.72 851.582)"
        />
        <path
          d="M425.73 373.27H450v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -227.573 850.977)"
        />
        <path
          d="M425.79 372.77h24.27v.11h-24.27z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-30.72 -227.511 850.465)"
        />
        <path
          d="M416.28 388.08h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 91.645 457.252)"
        />
        <path
          d="M417.45 387.36h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 92.817 456.531)"
        />
        <path
          d="M416.85 387.75h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 92.216 456.915)"
        />
        <path
          d="M417.96 387.08h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 93.326 456.246)"
        />
        <path
          d="M419.13 386.36h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 94.499 455.526)"
        />
        <path
          d="M418.54 386.74h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 93.904 455.915)"
        />
        <path
          d="M419.64 386.08h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.5 96.478 456.34)"
        />
        <path
          d="M420.81 385.36h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 96.175 454.526)"
        />
        <path
          d="M420.22 385.74h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 95.586 454.909)"
        />
        <path
          d="M421.32 385.07h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 96.691 454.246)"
        />
        <path
          d="M422.49 384.35h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 97.857 453.52)"
        />
        <path
          d="M421.9 384.74h20.58v.11H421.9z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 97.263 453.91)"
        />
        <path
          d="M423.01 384.13h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 98.378 453.296)"
        />
        <path
          d="M424.18 383.41h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 99.55 452.575)"
        />
        <path
          d="M423.58 383.79h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 98.95 452.96)"
        />
        <path
          d="M424.69 383.13h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 100.06 452.29)"
        />
        <path
          d="M425.86 382.4h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 101.227 451.576)"
        />
        <path
          d="M425.27 382.79h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 100.632 451.954)"
        />
        <path
          d="M426.38 382.14h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 101.744 451.306)"
        />
        <path
          d="M427.55 381.41h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 102.91 450.581)"
        />
        <path
          d="M426.95 381.8h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 102.32 450.964)"
        />
        <path
          d="M428.06 381.13h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 103.426 450.3)"
        />
        <path
          d="M429.23 380.41h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 104.598 449.58)"
        />
        <path
          d="M428.63 380.79h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 104.002 449.958)"
        />
        <path
          d="M429.74 380.13h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 105.108 449.295)"
        />
        <path
          d="M430.91 379.41h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 106.28 448.575)"
        />
        <path
          d="M430.31 379.79h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 105.68 448.959)"
        />
        <path
          d="M431.42 379.13H452v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.5 108.275 449.326)"
        />
        <path
          d="M432.59 378.4h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 107.962 447.57)"
        />
        <path
          d="M432 378.79h20.58v.11H432z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 107.367 447.958)"
        />
        <path
          d="M433.11 378.18h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 108.478 447.35)"
        />
        <path
          d="M434.28 377.46h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 109.644 446.625)"
        />
        <path
          d="M433.68 377.84h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 109.05 447.014)"
        />
        <path
          d="M434.79 377.18h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 110.16 446.345)"
        />
        <path
          d="M435.37 376.84h20.58v.11h-20.58z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-78.75 110.731 446.008)"
        />
        <path
          d="M433.5 379.76a25.54 25.54 0 0 1-5.79-.59v-.1a26.28 26.28 0 0 0 6.25.57v.11zM433.45 379.17a23.66 23.66 0 0 1-5.49-.56v-.1a24.22 24.22 0 0 0 6 .55v.11zM433.54 380.92a27.79 27.79 0 0 1-6.06-.61v-.1a28.7 28.7 0 0 0 6.47.6v.11zM433.53 380.34a26.61 26.61 0 0 1-5.93-.6v-.1a28.3 28.3 0 0 0 6.36.59v.1zM433.47 382a29.3 29.3 0 0 1-6.14-.58v-.11a30 30 0 0 0 6.62.58v.11zM433.56 381.39a29.34 29.34 0 0 1-6.17-.61v-.11a29.44 29.44 0 0 0 6.56.61v.1zM433.52 383.13a31.46 31.46 0 0 1-6.47-.61v-.1a32.05 32.05 0 0 0 6.91.6v.11zM433.47 382.55a30.93 30.93 0 0 1-6.31-.58v-.11a31.7 31.7 0 0 0 6.8.58v.11zM433.56 384.29a34.69 34.69 0 0 1-6.73-.62v-.11a34.06 34.06 0 0 0 7.13.62v.11zM433.62 383.71A33 33 0 0 1 427 383v-.11a33.37 33.37 0 0 0 7 .67v.11zM433.41 385.46a35.9 35.9 0 0 1-6.8-.58v-.11a36.83 36.83 0 0 0 7.35.58v.11zM433.58 384.88a35.26 35.26 0 0 1-6.87-.64v-.11a36 36 0 0 0 7.25.64v.1zM433.47 386.51a38.53 38.53 0 0 1-7.08-.6v-.11a39.06 39.06 0 0 0 7.57.6v.11zM433.43 385.93a37.13 37.13 0 0 1-6.93-.59v-.11a38 38 0 0 0 7.46.59v.1zM433.66 387.67a41.6 41.6 0 0 1-7.48-.73v-.11a41.08 41.08 0 0 0 7.78.73v.11zM433.49 387.09a39.11 39.11 0 0 1-7.22-.61v-.11a40.37 40.37 0 0 0 7.73.63v.11zM433.63 388.25a42.29 42.29 0 0 1-7.56-.7v-.11a42.53 42.53 0 0 0 7.9.7v.11zM433.55 389.42a44.4 44.4 0 0 1-7.73-.65v-.1a46.18 46.18 0 0 0 8.14.64v.1zM433.63 388.83a42.38 42.38 0 0 1-7.68-.71v-.1a43.24 43.24 0 0 0 8 .7v.11zM433.39 390.58a46.73 46.73 0 0 1-7.8-.59v-.11a47.85 47.85 0 0 0 8.38.59v.11zM433.35 390a44.83 44.83 0 0 1-7.62-.58v-.11a46.08 46.08 0 0 0 8.23.58v.11zM433.43 391.74a48.74 48.74 0 0 1-8.07-.61v-.1a50.41 50.41 0 0 0 8.6.6v.11zM433.41 391.16a48.43 48.43 0 0 1-7.94-.6v-.11a49.1 49.1 0 0 0 8.49.6v.11zM433.44 392.79a51.07 51.07 0 0 1-8.28-.62v-.11a50.83 50.83 0 0 0 8.81.62v.11zM433.35 392.21a49.4 49.4 0 0 1-8.09-.58v-.11a50.77 50.77 0 0 0 8.7.58v.11zM433.34 394a52.85 52.85 0 0 1-8.38-.59v-.1a54.74 54.74 0 0 0 9 .57v.12zM433.58 393.37a52.74 52.74 0 0 1-8.52-.71v-.11a52.87 52.87 0 0 0 8.9.71v.11zM433.3 395.12a57 57 0 0 1-8.61-.59v-.11a58.37 58.37 0 0 0 9.31.58v.11zM433.27 394.54a55.08 55.08 0 0 1-8.45-.58v-.11a56.75 56.75 0 0 0 9.14.58v.11zM433.34 396.28a60.15 60.15 0 0 1-8.87-.6v-.11a60.11 60.11 0 0 0 9.5.6v.11zM433.32 395.7a57.24 57.24 0 0 1-8.74-.6v-.1a59.8 59.8 0 0 0 9.38.59v.11zM433.39 397.33a63.47 63.47 0 0 1-9.13-.61v-.11a62.68 62.68 0 0 0 9.7.61v.11zM433.37 396.75a60.31 60.31 0 0 1-9-.61V396a62.55 62.55 0 0 0 9.59.61v.11zM433.29 398.5a64.54 64.54 0 0 1-9.26-.59v-.1a66.62 66.62 0 0 0 9.94.57v.11zM433.28 397.91a63.49 63.49 0 0 1-9.14-.58v-.11a64 64 0 0 0 9.82.58v.11z"
          style={{
            fill: "#fff",
          }}
          transform="translate(-337.39 -272.88)"
        />
        <path
          d="M87.37 125.99l-.11-.02 3.93-20.77.11.02-3.93 20.77zM88.26 125.99l-.1-.02 3.74-20.84.11.02-3.75 20.84zM95.27 126.53h-.11l.16-21.24h.11l-.16 21.24z"
          style={{
            fill: "#fff",
          }}
        />
        <path
          d="M421.42 388.66h21.2v.11h-21.2z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-89.4 125.039 422.668)"
        />
        <path
          d="M93.77 126.38h-.11l.44-21.1h.11l-.44 21.1zM91.13 126.23l-.11-.01 2.28-21.09.1.01-2.27 21.09z"
          style={{
            fill: "#fff",
          }}
        />
        <path
          d="M420.36 388.58h21v.11h-21z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-88.08 121.08 426.643)"
        />
        <path
          d="M418.45 388.44h21.11v.11h-21.11z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-82.95 105.996 442.895)"
        />
        <path
          d="M417.68 388.41h21.04v.11h-21.04z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-81.33 100.666 448.385)"
        />
        <path
          d="M92.19 126.23l-.11-.01 1.45-21.08h.11l-1.45 21.09z"
          style={{
            fill: "#fff",
          }}
        />
        <path
          d="M424 399l-.61-.12 3.88-19.74a1.69 1.69 0 0 1 1.74-1.35l5.34.31v.62l-5.34-.31a1.06 1.06 0 0 0-1.1.85z"
          style={{
            fill: "url(#s-5a64174af5-aa)",
          }}
          transform="translate(-337.39 -272.88)"
        />
        <path
          d="M434.48 400.8l-1-.41.06-22.07a1.56 1.56 0 0 1 .76-1.32l20.15-12.17a.35.35 0 0 1 .31 0l.76.22a.38.38 0 0 1 .27.39l-.92 23.24-.93-.06v-21.71a.39.39 0 0 0-.59-.33l-18.12 10.94a1.55 1.55 0 0 0-.75 1.33z"
          style={{
            fill: "url(#s-5a64174af5-ab)",
          }}
          transform="translate(-337.39 -272.88)"
        />
        <path
          d="M434.69 400.67l-.28.28.07-22.1a1.57 1.57 0 0 1 .75-1.33l20-12.06a.39.39 0 0 1 .59.33v20.63a3.1 3.1 0 0 1-.92 2.2v-21.2a.39.39 0 0 0-.59-.33l-18.11 10.94a1.56 1.56 0 0 0-.76 1.33v19.54a2.47 2.47 0 0 1-.75 1.77z"
          style={{
            fill: "url(#s-5a64174af5-ac)",
          }}
          transform="translate(-337.39 -272.88)"
        />
      </g>
      <g id="unihockeyRight">
        <path
          d="M317.23 153.29l-50.83-3.3-4.08-32.27 45.54 2.72 9.37 32.85z"
          style={{
            fill: "none",
            stroke: "#fff",
            strokeMiterlimit: "10",
          }}
        />
        <path
          d="M305.27 145.23l10.94.62v-1l-6.53-19.46-9.71.22v1l8.49.47 5.45 17.05-8.65.1.01 1z"
          style={{
            fill: "url(#s-5a64174af5-ad)",
          }}
        />
        <path
          d="M305.28 144.23l10.93.62-6.53-19.46-10.16-.47.52.69 9.03.51 5.86 18.06-9.85-.56.2.61z"
          style={{
            fill: "url(#s-5a64174af5-ae)",
          }}
        />
        <path
          d="M646.6 399.27c-1 0-2.08 0-3.29-.13V399a36.15 36.15 0 0 0 7-.07v.1a34 34 0 0 1-3.71.24zM646.54 398.75c-.95 0-2-.05-3.18-.14v-.09a34 34 0 0 0 6.73-.08v.1a32 32 0 0 1-3.55.21zM646.58 400.33c-1.06 0-2.17-.05-3.36-.14v-.09a39.61 39.61 0 0 0 7.26-.08v.1a36.22 36.22 0 0 1-3.9.21zM646.58 399.8c-1 0-2.12 0-3.31-.13v-.1a38.31 38.31 0 0 0 7.14-.08v.1a35 35 0 0 1-3.83.21zM646.76 401.29c-1.12 0-2.28-.05-3.62-.14v-.1a41.48 41.48 0 0 0 7.42-.05v.1a38.16 38.16 0 0 1-3.8.19zM646.58 400.75c-1.08 0-2.2 0-3.4-.13v-.1a39.82 39.82 0 0 0 7.36-.08v.1a36.92 36.92 0 0 1-3.96.21zM646.79 402.35a49.7 49.7 0 0 1-3.74-.15v-.1a44.27 44.27 0 0 0 7.75-.05v.1c-1.33.13-2.64.2-4.01.2zM646.9 401.82c-1.18 0-2.42-.05-3.81-.15v-.1a42.81 42.81 0 0 0 7.62 0v.1c-1.26.09-2.49.15-3.81.15zM646.79 403.4q-1.86 0-3.84-.15v-.1a47.18 47.18 0 0 0 8 0v.1c-1.31.08-2.71.15-4.16.15zM646.32 402.85c-1.1 0-2.19 0-3.32-.12v-.1a45 45 0 0 0 7.86-.11v.1c-1.55.15-3.04.23-4.54.23zM647.17 404.48c-1.33 0-2.71-.06-4.31-.17v-.1a49.21 49.21 0 0 0 8.24 0v.1c-1.35.11-2.61.17-3.93.17zM646.8 403.92c-1.27 0-2.58 0-3.89-.14v-.1a48.61 48.61 0 0 0 8.12-.05v.1c-1.31.13-2.75.19-4.23.19zM647.22 405.43c-1.4 0-2.85-.06-4.44-.17v-.1a53.4 53.4 0 0 0 8.49 0v.1c-1.34.11-2.67.17-4.05.17zM647.2 404.9c-1.36 0-2.77 0-4.37-.17v-.1a52 52 0 0 0 8.37 0v.1c-1.37.12-2.66.17-4 .17zM646.27 406.44c-1.12 0-2.32 0-3.58-.13v-.1a55.1 55.1 0 0 0 8.72-.1v.1c-1.41.11-3.14.23-5.14.23zM647.23 406c-1.43 0-2.91-.06-4.5-.17v-.1a56.3 56.3 0 0 0 8.62 0v.1c-1.35.07-2.7.17-4.12.17zM646.54 407c-1.31 0-2.61-.05-3.9-.14v-.1a58.44 58.44 0 0 0 8.86-.07v.1c-1.69.12-3.34.21-4.96.21zM647.31 408.06c-1.56 0-3.17-.05-4.76-.17v-.1a61.68 61.68 0 0 0 9.12 0v.1c-1.34.11-2.83.17-4.36.17zM646.6 407.51c-1.35 0-2.69-.05-4-.14v-.1a60.12 60.12 0 0 0 9-.07v.1c-1.69.14-3.36.21-5 .21zM647.78 409.15c-1.66 0-3.38-.07-5.32-.2v-.1a64.18 64.18 0 0 0 9.38.06v.1c-1.36.1-2.69.14-4.06.14zM647.72 408.63c-1.61 0-3.26-.07-5.21-.21v-.1a63.49 63.49 0 0 0 9.22.07v.1c-1.38.09-2.68.14-4.01.14zM647.86 410.21c-1.74 0-3.55-.07-5.49-.21v-.1a69.23 69.23 0 0 0 9.63.1v.1c-1.35.06-2.73.11-4.14.11zM647.82 409.68c-1.7 0-3.46-.07-5.41-.21v-.1a67.51 67.51 0 0 0 9.51.07v.1c-1.36.09-2.71.14-4.1.14zM648.09 411.16c-1.66 0-3.38-.07-5.32-.2v-.1a64.18 64.18 0 0 0 9.38.06v.1c-1.36.09-2.69.14-4.06.14zM648.19 410.65c-1.81 0-3.73-.07-5.86-.23v-.09a71.39 71.39 0 0 0 9.74.1v.09c-1.24.09-2.53.13-3.88.13zM648.63 412.25c-1.73 0-3.58-.08-5.81-.24v-.1a64.75 64.75 0 0 0 9.45.12v.1c-1.19.08-2.38.12-3.64.12zM647.38 411.65c-1.52 0-3-.06-4.61-.17v-.1a63.3 63.3 0 0 0 9.44 0v.1c-1.73.11-3.3.17-4.83.17zM648.66 413.31c-1.68 0-3.37-.08-5.67-.24V413a64.8 64.8 0 0 0 9.49.12v.1c-1.41.05-2.62.09-3.82.09zM648.58 412.78c-1.64 0-3.29-.08-5.59-.24v-.1a63.46 63.46 0 0 0 9.39.12v.1c-1.38.08-2.61.12-3.8.12zM648.13 414.39c-1.57 0-3.21-.06-5.27-.2v-.1a70 70 0 0 0 9.79.06v.1c-1.65.09-3.04.14-4.52.14zM648.71 413.83c-1.74 0-3.5-.07-5.79-.23v-.1a69.85 69.85 0 0 0 9.64.12v.1c-1.39.08-2.62.11-3.85.11zM648.2 415.34c-1.62 0-3.34-.06-5.43-.2V415a73.21 73.21 0 0 0 10 .06v.1c-1.56.13-3.02.18-4.57.18zM648.16 414.82c-1.59 0-3.27-.06-5.34-.21v-.1a73 73 0 0 0 9.88.07v.1c-1.59.08-3.02.14-4.54.14zM648.76 416.42c-1.91 0-3.85-.07-6.08-.23v-.1a78.89 78.89 0 0 0 10.27.12v.1c-1.44.07-2.81.11-4.19.11zM648.64 415.89c-1.86 0-3.73-.07-5.91-.23v-.1a75 75 0 0 0 10.14.11v.1c-1.48.08-2.87.12-4.23.12z"
          style={{
            fill: "#fff",
          }}
          transform="translate(-337.39 -272.88)"
        />
        <path
          d="M314.74 144.47l-2.3-19.23.1-.01 2.3 19.23-.1.01z"
          style={{
            fill: "#fff",
          }}
        />
        <path
          d="M650.16 397.93h.1v19.56h-.1z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-5.8 -2212.184 3601.113)"
        />
        <path
          d="M306.25 144.03h-.1l.08-19.19h.1l-.08 19.19zM306.92 144h-.1l.08-19.08h.1l-.08 19.08zM307.64 144.14h-.09l.14-19.22h.1l-.15 19.22z"
          style={{
            fill: "#fff",
          }}
        />
        <path
          d="M647.63 397.88h.1v19.19h-.1z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-1.57 -9478.48 12582.989)"
        />
        <path
          d="M308.52 124.92h.1v19.28h-.1z"
          style={{
            fill: "#fff",
          }}
        />
        <path
          d="M648.33 397.91h.1v19.33h-.1z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-2.39 -6060.511 8358.692)"
        />
        <path
          d="M649.3 397.92h.1v19.48h-.1z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-4.12 -3312.944 4961.035)"
        />
        <path
          d="M646.74 397.8h.1v19.3h-.1z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-.81 -18825.598 24134.974)"
        />
        <path
          d="M640.16 380.67c-.7 0-1.44 0-2.26-.07v-.1a28.44 28.44 0 0 0 6.2-.22v.1a26.52 26.52 0 0 1-3.94.29zM640.17 380.15c-.68 0-1.4 0-2.23-.07V380a26.9 26.9 0 0 0 6-.21v.1a25.48 25.48 0 0 1-3.77.26zM640.1 381.71c-.72 0-1.47 0-2.26-.07v-.1a31.33 31.33 0 0 0 6.43-.22v.09a28.7 28.7 0 0 1-4.17.3zM640.12 381.19c-.71 0-1.45 0-2.25-.07V381a30.25 30.25 0 0 0 6.32-.22v.1a29.06 29.06 0 0 1-4.07.31zM640.27 382.66c-.77 0-1.58 0-2.48-.08v-.1a32.11 32.11 0 0 0 6.58-.2v.1a30 30 0 0 1-4.1.28zM640.07 382.13c-.72 0-1.47 0-2.25-.07V382a31.48 31.48 0 0 0 6.52-.23v.1a29.89 29.89 0 0 1-4.27.26zM640.23 383.7c-.8 0-1.63 0-2.5-.07v-.1a35.68 35.68 0 0 0 6.86-.21v.1a32.86 32.86 0 0 1-4.36.28zM640.34 383.18c-.81 0-1.66 0-2.58-.08v-.1a33.6 33.6 0 0 0 6.75-.19v.1a30 30 0 0 1-4.17.27zM640.16 384.74c-.82 0-1.65 0-2.5-.07v-.1a38 38 0 0 0 7.08-.22v.1a33.79 33.79 0 0 1-4.58.29zM639.83 384.21c-.7 0-1.41 0-2.14-.06v-.1a36.17 36.17 0 0 0 7-.27v.1a36.45 36.45 0 0 1-4.86.33zM640.55 385.8c-.91 0-1.87 0-2.95-.09v-.1a39.54 39.54 0 0 0 7.29-.16v.1a37.74 37.74 0 0 1-4.34.25zM640.13 385.26c-.82 0-1.66 0-2.5-.07v-.1a38.32 38.32 0 0 0 7.19-.22v.1a36.76 36.76 0 0 1-4.69.29zM640.5 386.74c-.94 0-1.91 0-3-.09v-.1a42.08 42.08 0 0 0 7.52-.17v.1a38.1 38.1 0 0 1-4.52.26zM640.54 386.22c-.92 0-1.89 0-3-.09V386a40.87 40.87 0 0 0 7.41-.16v.1a39.09 39.09 0 0 1-4.41.28zM639.72 387.76c-.72 0-1.46 0-2.24-.06v-.1a45.49 45.49 0 0 0 7.72-.28v.1a49.49 49.49 0 0 1-5.48.34zM640.49 387.26c-1 0-1.94 0-3-.09v-.09a44.24 44.24 0 0 0 7.63-.18v.1a39.38 39.38 0 0 1-4.63.26zM639.9 388.29c-.82 0-1.64 0-2.45-.07v-.1a46.29 46.29 0 0 0 7.84-.25v.1a48.22 48.22 0 0 1-5.39.32zM640.42 389.35c-1 0-2 0-3-.09v-.1a48.47 48.47 0 0 0 8.07-.18v.1a44.44 44.44 0 0 1-5.07.27zM639.92 388.81c-.84 0-1.68 0-2.5-.07v-.1a46.39 46.39 0 0 0 8-.25v.1a48.58 48.58 0 0 1-5.5.32zM640.9 390.41c-1.12 0-2.29 0-3.57-.11v-.1a51.57 51.57 0 0 0 8.31-.12v.1a46.64 46.64 0 0 1-4.74.23zM640.92 389.89c-1.1 0-2.26 0-3.56-.11v-.1a48.67 48.67 0 0 0 8.16-.12v.1a45.08 45.08 0 0 1-4.6.23zM640.89 391.45c-1.16 0-2.35 0-3.62-.1v-.1a55.56 55.56 0 0 0 8.53-.13v.1a49 49 0 0 1-4.91.23zM640.9 390.93c-1.14 0-2.33 0-3.6-.1v-.1a54.1 54.1 0 0 0 8.42-.13v.1a47.94 47.94 0 0 1-4.82.23zM640.9 392.4c-1.19 0-2.41 0-3.69-.11v-.1a56.91 56.91 0 0 0 8.73-.13v.1c-1.61.16-3.28.24-5.04.24zM641.18 391.89c-1.23 0-2.53 0-3.94-.12v-.1a56.42 56.42 0 0 0 8.62-.1v.1c-1.47.14-3.01.22-4.68.22zM641.35 393.46c-1.32 0-2.72 0-4.2-.13v-.1a60.37 60.37 0 0 0 8.92-.08v.1c-1.41.14-3 .21-4.72.21zM640.21 392.9c-1 0-2 0-3-.09v-.1a57.26 57.26 0 0 0 8.83-.21v.1c-2.04.2-3.94.3-5.83.3zM641.36 394.5c-1.33 0-2.72 0-4.27-.13v-.09a63.34 63.34 0 0 0 9.19-.08v.1c-1.67.14-3.28.2-4.92.2zM641.35 394c-1.3 0-2.67 0-4.23-.13v-.1a60.42 60.42 0 0 0 9.07-.07v.1c-1.67.11-3.19.2-4.84.2zM641.37 395.55c-1.37 0-2.8-.05-4.34-.13v-.1a66.59 66.59 0 0 0 9.42-.08v.1c-1.68.14-3.34.21-5.08.21zM641.37 395c-1.35 0-2.76 0-4.31-.13v-.1a64.88 64.88 0 0 0 9.3-.08v.1c-1.67.21-3.28.21-4.99.21zM641.37 396.49c-1.41 0-2.87-.05-4.4-.13v-.1a69.31 69.31 0 0 0 9.61-.08v.1c-1.66.14-3.4.21-5.21.21zM641.37 396c-1.39 0-2.84-.05-4.37-.13v-.1a67.74 67.74 0 0 0 9.5-.08v.1c-1.66.11-3.35.21-5.13.21zM641.89 397.55c-1.56 0-3.23-.05-5-.15v-.1a71 71 0 0 0 9.85 0v.1c-1.46.09-3.09.15-4.85.15zM641.81 397c-1.52 0-3.14 0-4.87-.15v-.1a71 71 0 0 0 9.74 0v.1c-1.51.15-3.13.15-4.87.15z"
          style={{
            fill: "#fff",
          }}
          transform="translate(-337.39 -272.88)"
        />
        <path
          d="M644.84 379.37h.1v19.11h-.1z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-7.17 -1701.494 2945.065)"
        />
        <path
          d="M644.12 379.27h.1v19.31h-.1z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-6.26 -2020.063 3337.159)"
        />
        <path
          d="M300.78 125.41l-.02-19.1h.1l.02 19.1h-.1z"
          style={{
            fill: "#fff",
          }}
        />
        <path
          d="M638.84 379.28h.1v18.95h-.1z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-.13 -119780.644 148961.081)"
        />
        <path
          d="M639.61 379.28h.1v18.94h-.1z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-.31 -49972.574 62603.996)"
        />
        <path
          d="M304.89 125.34l-.81-18.95h.1l.81 18.94-.1.01z"
          style={{
            fill: "#fff",
          }}
        />
        <path
          d="M640.41 379.28h.1v18.99h-.1z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-.75 -20374.941 26026.353)"
        />
        <path
          d="M642.5 379.27h.1v19.1h-.1z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-3.2 -4410.85 6291.705)"
        />
        <path
          d="M643.36 379.28h.1v19.24h-.1z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-4.75 -2815.25 4319.633)"
        />
        <path
          d="M641.15 379.18h.1v19.09h-.1z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-1.41 -10616.523 13960.67)"
        />
        <path
          d="M646.47 398.63l-2.19-18.13c-.07-.79-.94-.93-1.66-.91l-6-.19v-.57l6 .19c1.89 0 2.19 1 2.22 1.42l2.2 18.12z"
          style={{
            fill: "url(#s-5a64174af5-af)",
          }}
          transform="translate(-337.39 -272.88)"
        />
        <path
          d="M647.17 400L645 381.83a1.3 1.3 0 0 0-1.24-1.18l-6-.2v-.1l6 .2a1.4 1.4 0 0 1 1.34 1.27l2.17 18.18z"
          style={{
            fill: "#fff",
          }}
          transform="translate(-337.39 -272.88)"
        />
        <path
          d="M647.64 401.25l-2.19-18.14a1.31 1.31 0 0 0-1.24-1.18l-6-.2v-.1l6 .2a1.42 1.42 0 0 1 1.34 1.27l2.19 18.14z"
          style={{
            fill: "#fff",
          }}
          transform="translate(-337.39 -272.88)"
        />
        <path
          d="M648.14 402.86L646 384.72a1.31 1.31 0 0 0-1.24-1.18l-6-.2v-.1l6 .2a1.42 1.42 0 0 1 1.34 1.27l2.19 18.14z"
          style={{
            fill: "#fff",
          }}
          transform="translate(-337.39 -272.88)"
        />
        <path
          d="M648.59 404l-2.19-18.13a1.33 1.33 0 0 0-1.24-1.19l-6-.19v-.1l6 .19a1.42 1.42 0 0 1 1.34 1.28l2.19 18.14z"
          style={{
            fill: "#fff",
          }}
          transform="translate(-337.39 -272.88)"
        />
        <path
          d="M649.05 405.34l-2.19-18.13a1.31 1.31 0 0 0-1.24-1.19l-6-.19v-.1l6 .19a1.42 1.42 0 0 1 1.38 1.28l2.19 18.13z"
          style={{
            fill: "#fff",
          }}
          transform="translate(-337.39 -272.88)"
        />
        <path
          d="M649.52 406.69l-2.19-18.14a1.31 1.31 0 0 0-1.24-1.18l-6-.2v-.1l6 .2a1.41 1.41 0 0 1 1.34 1.27l2.19 18.13z"
          style={{
            fill: "#fff",
          }}
          transform="translate(-337.39 -272.88)"
        />
        <path
          d="M650 408.3l-2.2-18.13a1.3 1.3 0 0 0-1.24-1.18l-6-.2v-.1l6 .2a1.4 1.4 0 0 1 1.33 1.27l2.19 18.13z"
          style={{
            fill: "#fff",
          }}
          transform="translate(-337.39 -272.88)"
        />
        <path
          d="M650.51 409.72l-2.19-18.13a1.32 1.32 0 0 0-1.24-1.19l-6-.19v-.1l6 .19a1.43 1.43 0 0 1 1.34 1.28l2.19 18.13z"
          style={{
            fill: "#fff",
          }}
          transform="translate(-337.39 -272.88)"
        />
        <path
          d="M651 411.16L648.79 393a1.3 1.3 0 0 0-1.24-1.18l-6-.2v-.1l6 .2a1.4 1.4 0 0 1 1.34 1.27l2.19 18.13z"
          style={{
            fill: "#fff",
          }}
          transform="translate(-337.39 -272.88)"
        />
        <path
          d="M651.46 412.59l-2.19-18.13a1.33 1.33 0 0 0-1.24-1.19l-6-.19V393l6 .19a1.42 1.42 0 0 1 1.34 1.28l2.19 18.13z"
          style={{
            fill: "#fff",
          }}
          transform="translate(-337.39 -272.88)"
        />
        <path
          d="M652 414.33l-2.19-18.13a1.31 1.31 0 0 0-1.24-1.18l-6-.2v-.1l6 .2a1.41 1.41 0 0 1 1.34 1.27l2.19 18.13z"
          style={{
            fill: "#fff",
          }}
          transform="translate(-337.39 -272.88)"
        />
        <path
          d="M652.44 415.66l-2.19-18.13a1.31 1.31 0 0 0-1.24-1.18l-6-.2v-.1l6 .2a1.41 1.41 0 0 1 1.34 1.27l2.19 18.13z"
          style={{
            fill: "#fff",
          }}
          transform="translate(-337.39 -272.88)"
        />
        <path
          d="M652.7 417.27l-2.19-18.13a1.07 1.07 0 0 0-1-1l-6.38-.2v-.57l6.39.2a1.64 1.64 0 0 1 1.56 1.49l2.19 18.12z"
          style={{
            fill: "url(#s-5a64174af5-ag)",
          }}
          transform="translate(-337.39 -272.88)"
        />
        <path
          d="M641.11 378.65h.1v19.33h-.1z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-17.86 -396.006 1325.387)"
        />
        <path
          d="M642.26 378.76h.1v19.37h-.1z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-17.47 -414.402 1349.923)"
        />
        <path
          d="M308.85 124.94l-5.71-18.56.1-.03 5.71 18.56-.1.03zM310.15 124.94l-6.09-18.62.09-.03 6.09 18.62-.09.03zM311.21 124.94l-6.31-18.52.1-.03 6.3 18.52-.09.03z"
          style={{
            fill: "#fff",
          }}
        />
        <path
          d="M646.56 378.9h.1v19.52h-.1z"
          style={{
            fill: "#fff",
          }}
          transform="rotate(-18.69 -351.04 1277.364)"
        />
        <path
          d="M642.86 418.3a.57.57 0 0 1-.57-.57v-20.11l-4.72-14.73v16.46a.57.57 0 0 1-.57.57.58.58 0 0 1-.57-.57v-20.11a.57.57 0 0 1 1.12-.18l5.83 18.21a.64.64 0 0 1 0 .24v20.22a.56.56 0 0 1-.52.57z"
          style={{
            fill: "url(#s-5a64174af5-ah)",
          }}
          transform="translate(-337.39 -272.88)"
        />
      </g>
    </g>
  </Fragment>
);

const defaultProps = {
  children,
  viewBox,
  fillColor: null,
  fillColorRule: "&&& path, &&& use, &&& g",
  size: null,
};

const propTypes = {
  fillColor: PropTypes.string,
  fillColorRule: PropTypes.string,
  viewBox: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  size: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      height: PropTypes.number.isRequired,
      width: PropTypes.number.isRequired,
    }),
  ]),
  sizes: (props, name, componentName) => {
    const prop = props[name];
    if (typeof prop !== "object") {
      return;
    }
    for (let key in prop) {
      if (
        !prop[key] ||
        typeof prop[key].width !== "number" ||
        typeof prop[key].height !== "number"
      ) {
        return new Error(
          "Invalid prop `" +
            name +
            "` supplied to `" +
            componentName +
            "`. Validation failed."
        );
      }
    }
  },
};

export default Object.assign(Image, {
  getDimensions,
  getCss,
  defaultProps,
  propTypes,
  displayName: "12x10",
});
